// extracted by mini-css-extract-plugin
export default {"num-highly-rated-conditions":"HighlyRatedBlock_num-highly-rated-conditions__5P1oi","number":"HighlyRatedBlock_number__eUY3H"};